import React from 'react';

const BownowContext = React.createContext();

export default BownowContext;